// extracted by mini-css-extract-plugin
module.exports = {"editor":"style_editor__F8KLf","folderShowCaseDrawer":"style_folderShowCaseDrawer__UIVNG"};